module.exports = __webpack_public_path__ + "img/bottom-arrow.29ce8418.svg";